import { format, isPast } from 'date-fns';

type Props = {
  date: Date;
};
const DateTab = ({ date }: Props) => {
  return (
    <div className={'flex flex-col shrink-0 text-center size-16 min-h-14'}>
      <span
        className={
          'flex-1 text-white content-center rounded-t-lg' +
          (isPast(date) ? ' bg-gray-500' : ' bg-red-400')
        }
      >
        {format(date, 'EEE')}
      </span>
      <span className="flex-1 bg-gray-100 content-center rounded-b-lg">
        {format(date, 'd MMM')}
      </span>
    </div>
  );
};

export default DateTab;
